import { useIsFetching } from '@tanstack/react-query';
import * as React from 'react';
import { useEffect, useState } from 'react';

export interface BackdropContext {
    backdrop: boolean;
    setBackdropOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const initState: BackdropContext = {
    backdrop: {} as boolean,
    setBackdropOpen: () => {},
};

const eventContext = React.createContext<BackdropContext>(initState);

export function BackdropProvider(props: Readonly<{ children: React.ReactNode }>): React.ReactElement {
    const [backdropOpen, setBackdropOpen] = useState<boolean>(false);
    const isFetching = useIsFetching();

    useEffect(() => {
        const handleStart = () => setBackdropOpen(true);
        const handleEnd = () => setBackdropOpen(false);

        window.addEventListener('fetch-start', handleStart);
        window.addEventListener('fetch-end', handleEnd);

        return () => {
            window.removeEventListener('fetch-start', handleStart);
            window.removeEventListener('fetch-end', handleEnd);
        };
    }, []);

    useEffect(() => {
        if (isFetching > 0) {
            setBackdropOpen(true);
        } else {
            setBackdropOpen(false);
        }
    }, [isFetching]);

    return (
        <eventContext.Provider value={{ backdrop: backdropOpen, setBackdropOpen: setBackdropOpen }}>
            {props.children}
        </eventContext.Provider>
    );
}

export function useBackdropContext() {
    return React.useContext(eventContext);
}
